import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';

interface LogDetailDialogProps {
  open: boolean;
  onClose: () => void;
  changedPayload: Record<string, any>;
}

const LogDetailDialog = ({ open, onClose, changedPayload }: LogDetailDialogProps) => {
  const [copied, setCopied] = useState(false);

  const formattedJson = JSON.stringify(changedPayload, null, 2);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(formattedJson);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Audit Log Details</Typography>
          <IconButton
            onClick={handleCopy}
            size="small"
            title={copied ? 'Copied!' : 'Copy to clipboard'}
            color={copied ? 'success' : 'default'}>
            {copied ? <CheckIcon /> : <ContentCopyIcon />}
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          component="pre"
          sx={{
            backgroundColor: 'grey.100',
            padding: 2,
            borderRadius: 1,
            overflow: 'auto',
            fontFamily: 'monospace',
            fontSize: '0.875rem',
            margin: 0,
          }}>
          {formattedJson}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogDetailDialog;
